import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import InputWithExtra from '../../Comman/components/InputWithExtra';
//import Popup from 'reactjs-popup'
import Modal from 'react-responsive-modal';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TwitterPicker ,ChromePicker,  } from 'react-color';
import 'primereact/resources/primereact.min.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {InputText} from 'primereact/inputtext';
import SimpleReactValidator from 'simple-react-validator';
import noimage from '../../Comman/images/no_image.png';
import loader from '../../Comman/images/loader.gif'
import {baseUrl} from '../../Comman/apiEndPoints'
import imageCompression from 'browser-image-compression';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import { DatePickerInput } from 'rc-datepicker';

import 'moment/locale/sv.js';
import 'moment/locale/en-sg.js';
import 'rc-datepicker/lib/style.css';

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
var svValidator;
var engValidator;
var currentLang;
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
const url=baseUrl;
const popover = {
      position: 'absolute',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }
var svValidator;
var engValidator;
var currentLang;
class NotificationDetailsComponent extends Component {
    toastId = null;
    constructor(props) {
        super(props);
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        var time = today.getHours() + ":" + (today.getMinutes() < 10 ? '0' : '') + today.getMinutes();
        if(dd<10) {
            dd = '0'+dd
        } 
      
        if(mm<10) {
            mm = '0'+ mm
        }  
        today =  yyyy + '-'+ mm + '-' + dd  ; 
        this.state = {
            notificationSettings: {
                NotifTypeId:'',
                NotifCategory:'',
                NotifHeader:'',
                NotifText:'',                
                NotifPicture: '',    
                NotificationFontType:'',                      
                NotificationFontColor:'#000',
                NotificationFontSize:'', 
                NotificationFontType_Bold:false, 
                NotificationFontType_Itallic:false, 
                NotificationFontType_Underline:false, 
                imagePreviewUrl: '', 
                NotifExpiryDate:'',
                NotifExpiryTime:'',
                NotifSendDate:'',
                NotifSendTime:'',
                NotifSendNow:false,
                NotifSend : false,
                RegionId:null,
                inputKey: Date.now()
            },
            open: false,
            rowimage:'',  
            displayFontColorPicker: false,
            displayButtonColorPicker: false,
            sendNowDate : '',
            sendNowTime : '',
            todayDate : yyyy+ '-'+ mm + '-' + dd, 
            minDate : yyyy+ '-'+ mm + '-' + dd,
            currentTime : time,
            sendNoti : '',
            showExpiry:false,
             validateImageField : '',
            validateHeader:'',
            ValidateText:'',
            RegionId:''
        };
        this.handleInput = this.handleInput.bind(this);
        this._handleImageChange = this._handleImageChange.bind(this);
        this.deleteNotificationSettings= this.deleteNotificationSettings.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this); 
        this.updateNotificationSettings = this.updateNotificationSettings.bind(this);
        this.actionColumn = this.actionColumn.bind(this); 
        this.baseState=this.state;
        if(sessionStorage.getItem('Language')){
            currentLang = sessionStorage.getItem('Language');
        }
        else{
            currentLang = "en";
        }
    }
 
    componentWillMount() { 
        SimpleReactValidator.addLocale('en', {
            required : 'The :attribute field is required.',
            min : 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required : 'Fältet :attribute krävs.',
            min : ':attribute måste vara minst :min tecken.'
        }); 
        engValidator = new SimpleReactValidator({
                locale : 'en'
            });
        svValidator = new SimpleReactValidator({
                locale : 'sv'
            });
        this.validator = engValidator;
      }
    componentWillReceiveProps(nextProps) { 
        if (nextProps.notificationSettings !== this.props.notificationSettings) {
             if(nextProps.statusCode==200){
                    this.notify(nextProps.notificationSettings.messageLabel)
                     this.closeModal();
                     this.setState(this.baseState);
            }
            if(nextProps.statusCode==201){
                this.errornotify(nextProps.notificationSettings.messageLabel)
            }
        } 
        this.translateLang();
    }
    translateLang(){
        var language;
        if(sessionStorage.getItem('Language')){
          language = sessionStorage.getItem('Language');
        }
        else{
          language = "en";
        }
        if(language == "en"){
          this.validator = engValidator;
        }
        else{
          this.validator = svValidator;
        }
      }
    handleInput(e) {  
        //debugger 
       let value = e.target.value;
       let name = e.target.name;
       if(name == "Type"){
        if(value=="bold"){
            if(e.target.checked){
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Bold:true
                    }, }))
            }
            else{
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Bold:false
                    }, }))
            }
        }
        if(value=="italic"){
            if(e.target.checked){
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Itallic:true
                    }, }))
            }
            else{
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Itallic:false
                    }, }))
            }
        }
        if(value=="underline"){
            if(e.target.checked){
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Underline:true
                    }, }))
            }
            else{
                this.setState( prevState => ({ notificationSettings : 
                    {...prevState.notificationSettings,
                        NotificationFontType_Underline:false
                    }, }))
            }
        }
  }
  else if(name == "NotifSendNow"){ 
      if(value =="Now") 
          value=true;  
     else
           value=false;  
 this.setState( prevState => ({ notificationSettings : 
     {...prevState.notificationSettings, [name]: value}
   }),  )
}
else{
      this.setState( prevState => ({ notificationSettings : 
        {...prevState.notificationSettings, [name]: value}
        }),  ) 
}
sleep(3000).then(() => {
    console.log("state",this.state);
  })
}
    handleExpiryDate = (jsDate) => {
        if(jsDate != 'Invalid date'){
            let dd = jsDate.getDate();
            let mm = jsDate.getMonth() + 1;
            let yy = jsDate.getFullYear();
            let date = yy + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
            this.setState( prevState => ({ notificationSettings : 
                {...prevState.notificationSettings,
                    NotifExpiryDate : date
                }
            }),  )
        }
    }
    handleSendDate = (jsDate) =>{
        if(jsDate != 'Invalid date'){
            let dd = jsDate.getDate();
            let mm = jsDate.getMonth() + 1;
            let yy = jsDate.getFullYear();
            let date = yy + '-' + (mm < 10 ? '0' : '') + mm + '-' + (dd < 10 ? '0' : '') + dd;
            this.setState( prevState => ({ notificationSettings : 
                {...prevState.notificationSettings,
                    NotifSendDate : date
                }
            }),  )

            sleep(2000).then(() => {
                this.setState({minDate : this.state.notificationSettings.NotifSendDate});
                console.log("state",this.state)
            })
        }
    }

    errornotify = (message) => { 
        swal({text : message, icon : 'error'})
        // this.toastId =toast.error(message, {
        //   position: toast.POSITION.TOP_CENTER
        // }); 
      }

    _handleImageChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];   
        var self=this;
        //   this.setState( prevState => ({
        //     notificationSettings : 
        //     {...prevState.notificationSettings,
        //         NotifPicture: file, 
        //     }, 
        //   })) 
          imageCompression(file, options)
          .then(function (compressedFile) {
              reader.onloadend = function() {
                  self.setState(prevState => ({ notificationSettings : 
                      {...prevState.notificationSettings,
                        NotifPicture: file,
                      },
                      }))
              }
            reader.readAsDataURL(file);
            sleep(500).then(() => {
                  self.setState({validateImageField : ''})
                document.getElementById("currentimgsrc").src = URL.createObjectURL(file); 
            })
          })
          .catch(function (error) {
              console.log(error);
          });
    }
 
    rendernotificationSettings = () => {
        console.log(this.props.notificationSettings) 
    }

    closeModal() {
        this.setState({ open: false })
        this.setState(this.baseState); 
    }

    openModal(rowData) {
        this.setState({ open: true })    
        var date="",TDay="",TSenddate="",TExpdate=""; 
        sleep(500).then(() => { 
            let imgsrc=url+'/'+rowData.Picture;
            document.getElementById("notificationTypeDD").value = rowData.TypeId;//NotificationType
            document.getElementById("lblNotificationId").value = rowData.NotificationId; 
            document.getElementById("NotifCategoryDD").value = rowData.CategoryId ;//NotificationCategory
            document.getElementById("NotifHeader").value = rowData.Header; 
            document.getElementById("RegionId").value = rowData.RegionId;  
            // if(rowData.TypeId == "1" || rowData.TypeId == "2"){
            //     document.getElementById("currentimgsrc").src = imgsrc;
            // }
            if(rowData.TypeId == "2" || rowData.TypeId == "3"){
                document.getElementById("NotifText").value=rowData.Text;
                document.getElementById("fColor").style.background=rowData.TextColor;
                document.getElementById("NotifFontDD").value=rowData.FontType;
                document.getElementById("fSize").value=rowData.FontSize;

                if(rowData.Bold==='True'){
                    document.getElementById("fTypebold").checked = true;
                  }
                if(rowData.Cursives.trim()==='True'){
                      document.getElementById("fTypeitallic").checked = true;
                  }
                if(rowData.Underline.trim()==='True'){
                    document.getElementById("fTypeunderline").checked = true;
                  } 
            } 
            if(rowData.Sendnow==true){
                if(rowData.SendDate == "0001-01-01T00:00:00"){
                    return;
                }
                else if (rowData.SendDate != null &&  rowData.SendDate != undefined) {
                    let value_1 = rowData.SendDate.split('T');
                    let value_2 = value_1[1].split(':');
                    this.setState({
                        sendNowDate : value_1[0],
                        sendNowTime : value_2[0] + ":" + value_2[1],
                        sendNoti : 'Now'
                    })
                }
            }
            if(rowData.Sendnow==false){
                this.setState({
                    sendNowDate : this.state.todayDate,
                    sendNowTime : this.state.currentTime,
                    sendNoti : "Later"
                })    
                document.getElementById("NotifSendNow").checked=rowData.Sendnow==true?true:false; 
                document.getElementById("NotifSendLater").checked=rowData.Sendnow==false?true:false;
                if(rowData.ScheduledDate == "0001-01-01T00:00:00"){
                    return;
                }
                else if(rowData.ScheduledDate != null && rowData.ScheduledDate != undefined){
                    let value_1 = rowData.ScheduledDate.split('T');
                    let value_2 = value_1[1].split(':');
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings, 
                            NotifSendDate: value_1[0],
                            NotifSendTime: value_2[0] + ":" + value_2[1]
                        }
                        }),) 
                }
            } 
            if (rowData.ExpiryDate != null &&  rowData.ExpiryDate != undefined) {
                if(rowData.ExpiryDate == "0001-01-01T00:00:00"){
                    return;
                }
                else{
                    let date = rowData.ExpiryDate.split('T');
                    let time = date[1].split(':');
                    this.setState( prevState => ({ notificationSettings : 
                        {...prevState.notificationSettings, 
                            NotifExpiryDate : date[0],
                            NotifExpiryTime : time[0] + ":" + time[1]             
                        }
                        }),) 
                        let date1 = new Date(rowData.ExpiryDate).getTime();
                        let date2 = new Date().getTime();
                        if(date1 <= date2){
                            this.setState({showExpiry : true})
                        }
                        else{
                            this.setState({showExpiry : false})
                        }
                }
            }
        })
         this.setState( prevState => ({ notificationSettings : 
        {...prevState.notificationSettings, 
            NotifTypeId:rowData.TypeId,
            NotifCategory:rowData.CategoryId,
            RegionId:rowData.RegionId,
            NotifHeader:rowData.Header,
            NotifText:rowData.Text,                
            NotifPicture: rowData.Picture,                       
            NotificationFontColor:rowData.TextColor,
            NotificationFontSize:rowData.FontSize,   
            NotificationFontType:rowData.FontType,         
            NotificationFontType_Bold:rowData.Bold =='True'?true:false, 
            NotificationFontType_Itallic:rowData.Cursives=='True'?true:false, 
            NotificationFontType_Underline:rowData.Underline=='True'?true:false, 
            // NotifExpiryDate:TExpdate,
            // NotifSendDate:TSenddate,
            NotifSendNow: rowData.Sendnow,
            NotifSend: rowData.Send
        }
        }),  )
        

    }
 
    IconData=(rowData)=> {
        let imgsrc;
        if(rowData.Picture!=''){ 
            imgsrc=url+'/'+rowData.Picture;
           
        }
        
        return (<span ><img className="iconimg" src={imgsrc} onError={this.handleError} alt=""/></span>)
    }
    handleError=()=>{
        this.setState({
            rowimage:noimage
         });
    }
 
    FontColor(rowData) {
        if(rowData.TextColor){
            return (<span className="box" style={{background:rowData.TextColor}}></span>)
        }
    }

    SendDate(rowData) {
    if (rowData.SendDate != null &&  rowData.SendDate != undefined) {
        if(rowData.SendDate == "0001-01-01T00:00:00"){
            return;
        }
        else{
            let value = rowData.SendDate.split('T');
            let data = value[1].split(':');
            return (<p className={rowData.Sendnow==true ? 'green-notifi':''}>{value[0] + " " + data[0] + ":" + data[1]}</p>) 
        }
    }
}

    ScheduledDate(rowData) {       
        if (rowData.ScheduledDate != null &&  rowData.ScheduledDate != undefined) {
            if(rowData.ScheduledDate == "0001-01-01T00:00:00"){
                return;
            }
            else{
                let value = rowData.ScheduledDate.split('T');
                let data = value[1].split(':');
                return (<p className={rowData.Send==true ?'green-notifi':'red-notifi'}>{value[0] + " " + data[0] + ":" + data[1]}</p>) 
            }
        }
    }

    ExpiryDate(rowData) {       
        if (rowData.ExpiryDate != null &&  rowData.ExpiryDate != undefined) {
            if(rowData.ExpiryDate == "0001-01-01T00:00:00"){
                return;
            }
            else{
                let value = rowData.ExpiryDate.split('T');
                let data = value[1].split(':');
                return (<span>{value[0] + " " + data[0] + ":" + data[1]}</span>) 
            }
        }
    }
    textNotifi(rowData){
        if(rowData.Text.length){
            let str1 = (rowData.Text).slice(0,40);
            if(rowData.Text.length > 40){
                return (str1.concat('...'));
            }
            else{
                return str1;
            }
        }
    }
     deleteNotificationSettings(rowData){  
        debugger
        const { t } = this.props;
        confirmAlert({
          title: `${t('First_Responder.Confirm to delete')}`,
          message: `${t('First_Responder.Are you sure to delete this?')}`,
          buttons: [
            {
              label: `${t('First_Responder.Yes')}`,
              onClick: () => {
                let notificationId=rowData.NotificationId
                let notificationSettings = this.state.notificationSettings;    
                debugger
                 this.props.deleteNotificationSettings({ NotificationId :notificationId},rowData.RegionId);
            }
            },
            {
              label: `${t('First_Responder.No')}`,
              onClick: () => {
              }
            }
          ]
        });
    } 

    actionColumn(rowData) {
        const { t } = this.props;
            return (
                <span>
                    <span onClick={() => { this.openModal(rowData) }} className="enable-cursor editicon" title={t('First_Responder.View')}>   
                        <i className="fa fa-pencil" aria-hidden="true"></i></span>
                    
                    <span onClick={() => { this.deleteNotificationSettings(rowData) }} title={t('First_Responder.Delete')} className="enable-cursor">
                    <i className="fa fa-lg fa-trash" aria-hidden="true"></i>
                    </span>   
                </span>
            ) 

    }

    updateNotificationSettings(){
        const { t } = this.props; 
        let notificationSettings = this.state.notificationSettings; 
        debugger
         if(this.state.notificationSettings.NotifTypeId == "1" || this.state.notificationSettings.NotifTypeId == "2"){
            if(this.state.notificationSettings.NotifPicture == ""){
                this.setState({validateImageField : `${t('Notification Setting.Picture is required')}` });
                return;
            }
        } 
        console.log(notificationSettings)
        // debugger
          if (this.validator.allValid()) { 
        const formData = new FormData();
            formData.append('NotificationId',document.getElementById("lblNotificationId").value)
            formData.append('TypeId',notificationSettings.NotifTypeId)
            if(notificationSettings.NotifTypeId == 1){
                formData.append('Text','')     
                formData.append('FontType','')
                formData.append('FontSize','')
                formData.append('Bold',false)
                formData.append('Cursives',false)
                formData.append('Underline',false)
            }
            else{
                formData.append('Text',notificationSettings.NotifText.trim())     
                formData.append('FontType',notificationSettings.NotificationFontType)
                formData.append('FontSize',notificationSettings.NotificationFontSize)
                formData.append('Bold',notificationSettings.NotificationFontType_Bold)
                formData.append('Cursives',notificationSettings.NotificationFontType_Itallic)
                formData.append('Underline',notificationSettings.NotificationFontType_Underline)
            }
            formData.append('CategoryId',notificationSettings.NotifCategory)
            formData.append('Header',notificationSettings.NotifHeader.trim()) 
            formData.append('TextColor',notificationSettings.NotificationFontColor)
            formData.append('NotifPicture',notificationSettings.NotifPicture ? notificationSettings.NotifPicture : null)
            
            formData.append('Sendnow',notificationSettings.NotifSendNow)
            // formData.append('ScheduledDate',notificationSettings.NotifSendDate)
            formData.append('SendDate','')
            formData.append('SchedDate',notificationSettings.NotifSendDate)
            formData.append('SchedTime',notificationSettings.NotifSendTime)
            formData.append('ExpiryDate',notificationSettings.NotifExpiryDate) 
            formData.append('ExpiryTime',notificationSettings.NotifExpiryTime)
                     if(notificationSettings.RegionId==null)
          {
            formData.append('RegionId',this.props.notificationSettings.regionList[0].ID)
           
          }
          else{
 formData.append('RegionId',notificationSettings.RegionId)
          }
            formData.append('ImageName',notificationSettings.NotifPicture ? notificationSettings.NotifPicture.name : '')
        this.props.updateNotificationSettings(formData,notificationSettings.RegionId);
          }
       else {
            this.validator.showMessages(); 
            this.forceUpdate();
        }   
        
    }
     notify = (message) => { 
        swal({text : message, icon : 'success'})
    //   this.toastId =toast.success(message, {
    //     position: toast.POSITION.TOP_CENTER
    //   }); 
      this.closeModal(); 
    }
    handleButtonBtnClick = () => {
        
        this.setState({ displayButtonColorPicker: !this.state.displayFontColorPicker })
    };
    handleFontBtnClick = (event) => {
        
        this.setState({ displayFontColorPicker: !this.state.displayFontColorPicker })
    };
    handleButtonClose = () => {
        this.setState({ displayButtonColorPicker: false })
    };
    handleFontBtnClose = () => {
        this.setState({ displayFontColorPicker: false })
    };
    
    handleFontColorChange = (color, event) => {
        let fntcolor=color.hex;
        fntcolor.trim();
        this.setState( prevState => ({ notificationSettings : 
          {...prevState.notificationSettings, NotificationFontColor: fntcolor}
        }),  )
    };

    truncateHeader(str) {
        if(str.Header)
        {
            return (<p>{str.Header.length > 20 ? str.Header.substring(0, 20) + "..." : str.Header}</p>)
        }
   
}
truncateText(str) {
        if(str.Text)
        {
            return (<p>{str.Text.length > 20 ? str.Text.substring(0, 20) + "..." : str.Text}</p>)
        }
   
}
     changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    render() {  
        const { t } = this.props;
          let  regionListOption;
      let regionList=this.props.notificationSettings.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        let  optionNotifType; 
        let NotifTypeVal = this.props.notificationSettings.notificationType;
       
        if(NotifTypeVal){
            optionNotifType = NotifTypeVal.map((NotifTypeValue) =>
                <option value={NotifTypeValue.TypeId} key={NotifTypeValue.TypeId}>{NotifTypeValue.Type}</option>
            );

        }
        let  optionNotifCategory; 
        let NotifCategoryVal = this.props.notificationSettings.notificationCategory;
       
        if(NotifCategoryVal){
            optionNotifCategory = NotifCategoryVal.map((NotifCategoryValue) =>
                <option value={NotifCategoryValue.CategoryId} key={NotifCategoryValue.CategoryId}>{NotifCategoryValue.Notificationcategory}</option>
            );

        } 
        let  optionNotifFont; 
        let NotifFontVal = this.props.notificationSettings.fontType;
        if(NotifFontVal){
            optionNotifFont = NotifFontVal.map((NotifFontValue) =>
                <option value={NotifFontValue.FontTypeName} key={NotifFontValue.FontTypeName}>{NotifFontValue.FontTypeName}</option>
            );

        }
        let {imagePreviewUrl} = this.state.notificationSettings;
        let $imagePreview = null;
        if (imagePreviewUrl) {
          $imagePreview = (<img src={imagePreviewUrl} alt=""/>);
        }
        var header = <div className="search-name">
                        <i className="fa fa-search" style={{margin:'4px 4px 0 0'}}></i>
                        <InputText type="text" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder={t('First_Responder.Search')} size="50"/>
                    </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Notification Setting.Notification Settings Details')}</h2>
                </div>
                  <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>
                {/* <ToastContainer />  */}
                 <div className="w3l_search m-b-15">
                    {header}
                </div>
                <div className="devicestable">
                    <div className="devicestable">
                    <DataTable  className="table no-border" value={this.props.notificationSettings.notificationList}  
                        globalFilter={this.state.globalFilter}  paginator={true} rows={10}
                        emptyMessage={t('First_Responder.No records found')}
                        >
                                    <Column sortable={true}  field="TypeId" header=""  className="noDisplay" />
                                    <Column sortable={true}  field="NotificationId" header=""  className="noDisplay" />
                                    <Column sortable={true} headerClassName="hideheader" field="NotificationType" header={t('Notification Setting.Type')} />
                                    <Column sortable={true} headerClassName="hideheader" field="NotificationCategory" header={t('Notification Setting.Category')} />
                                    <Column sortable={true} headerClassName="hideheader" field="Header" body={this.truncateHeader} header={t('Notification Setting.Header')} className="wordBreakLine" />
                                    <Column sortable={true} headerClassName="hideheader" field="Text" body={this.truncateText} header={t('Notification Setting.Text')}  className="wordBreakLine" />
                                    <Column sortable={true} headerClassName="hideheader" field="Picture" header={t('Notification Setting.Picture')} body={this.IconData}  />
                                    <Column sortable={true} headerClassName="hideheader" field="TextColor" header={t('Notification Setting.Color')} body={this.FontColor} />
                                    <Column sortable={true} headerClassName="hideheader" field="FontSize" header={t('Notification Setting.Font Size')} />
                                    <Column sortable={true} headerClassName="hideheader" field="FontType" header={t('Notification Setting.Font Type')} />
                                    <Column sortable={true}  field="Sendnow" header="Send Now" className="noDisplay" />
                                    <Column sortable={true} headerClassName="hideheader" field="SendDate" body={this.SendDate}  header={t('Notification Setting.Send Date')} />
                                    <Column sortable={true} headerClassName="hideheader" field="ScheduledDate" body={this.ScheduledDate} header={t('Notification Setting.Scheduled Date')} />
                                    <Column sortable={true} headerClassName="hideheader" field="ExpiryDate" body={this.ExpiryDate}  header={t('Notification Setting.Expiry Date')} />
                                    <Column headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')}  />
                        </DataTable> 
                       
                    </div>
                </div>      
                <Modal open={this.state.open}  onClose={this.closeModal} center> 
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                                 <h2>{t('Notification Setting.Notification Settings Update')}</h2>
                        </div>

                            <div className="">
                                <div className="forms add-device setting-panel">
                                    <div className="form-three widget-shadow">
                                        <div className=" panel-body-inputin notification-modal-lable">
                                            <form className="form-horizontal" >
                                   
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label">{t('Notification Setting.Notification Types')}</label>
                                            <label id="lblNotificationId" className="noDisplay"/>
                                            
                                            <div className="col-sm-9">
                                            <select  id="notificationTypeDD"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotifTypeId}
                                            placeholder="Select" 
                                            ref="NotifTypeId"
                                            name='NotifTypeId'
                                            className={(this.state.notificationSettings.NotifSendNow==true || this.state.notificationSettings.NotifSend==true) ? 'form-control1 disabled-notiTypes' : 'form-control1 FR-edit-details'}
                                        >
                                           {optionNotifType}  
                                        </select>
                                      </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Notification Setting.Notification Category')}</label>
                                            <div className="col-sm-9">
                                            <select  id="NotifCategoryDD"  className="form-control1 FR-edit-details"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotifTypeId}
                                            placeholder="Select" 
                                            ref="NotifCategory"
                                            name='NotifCategory'
                                        >
                                           {optionNotifCategory}  
                                        </select>
                                                
                                            </div>
                                            
                                        </div>
                                        <div className="form-group"> 
                                            <label className="col-sm-3 control-label">Region</label>
                                            <label id="RegionId" className="noDisplay"/>
                                            
                                            <div className="col-sm-9">
                                            <select  id="RegionId"
                                            onChange={this.handleInput} 
                                            value = {this.state.notificationSettings.RegionId}
                                            placeholder="Select" 
                                            ref="RegionId"
                                            name='RegionId'
                                            className= 'form-control1 FR-edit-details'
                                        >
                                           {regionListOption }  
                                        </select>
                                      </div>
                                            
                                        </div>
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Notification Setting.Notification Header')}</label>
                                            <div className="col-sm-9">
                                            <textarea rows={3}  id="NotifHeader" style={{height:'75px'}}
                                                    type={'text'}
                                                    title= {t('Notification Setting.Notification Header')} 
                                                    name= {'NotifHeader'}
                                                    defaultValue={this.state.notificationSettings.NotifHeader} 
                                                    placeholder = {t('Notification Setting.Enter Notification Header')}
                                                    onChange = {this.handleInput} 
                                                    className="form-control1 FR-edit-details" 
                                                    />  
                                                    {this.validator.message(`${t('Notification Setting.Notification Header')}`, this.state.notificationSettings.NotifHeader, 'required|min:2')}

                                            </div>
                                            
                                        </div>
                                        {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3") ?
                                        <div className="form-group">
                                                    
                                            <label className="col-sm-3 control-label">{t('Notification Setting.Notification Text')}</label>
                                            <div className="col-sm-9">
                                            <textarea rows="5" id="NotifText" style={{height:'75px'}}
                                                    title= {t('Notification Setting.Notification Text')}
                                                    name= {'NotifText'}
                                                    defaultValue={this.state.notificationSettings.NotifText} 
                                                    placeholder = {t('Notification Setting.Enter Notification Text')}
                                                    onChange = {this.handleInput} 
                                                    className="form-control1 hgt-60 FR-edit-details" 
                                                    />  
                                               {this.validator.message(`${t('Notification Setting.Notification Text')}`, this.state.notificationSettings.NotifText, 'required|min:2')}

 
                                            </div>
                                            
                                        </div> : '' }
                                        {(this.state.notificationSettings.NotifTypeId == "1" || this.state.notificationSettings.NotifTypeId == "2") ? 
                                        <div className="form-group"> 
                                                    <label className="col-sm-3 control-label">{t('Notification Setting.Notification Picture')}</label> 
                                                    <div className="col-sm-9 ">
                                                        <img className="notifi-img" src={url+'/'+this.state.notificationSettings.NotifPicture} id="currentimgsrc" alt="" /> 
                                                        <br/>                                   
                                                    <input type="file" accept="image/*" key={this.state.inputKey} onChange={this._handleImageChange}
                                                        id="imageUpload" className="hide_input_type_file" />
                                                    <label for="imageUpload" className="choose-file-btn">{t('Notification Setting.Select Image')}</label>
                                                  <p style={{"color":'red'}}>{this.state.validateImageField}</p>

                                                    </div>
                                                     
                                                </div> : ''}
                                               
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Notification Setting.Text Font Color')}</label> 
                                                <div className="col-sm-9 "> 
                                                            <span className="box" id="fColor" 
                                                                style={{background:this.state.notificationSettings.NotificationFontColor}}>
                                                            </span> 
                                                            <div>
                                                                <button type="button" className="pickcolorbtn pickbtn " 
                                                                id="modalfcolor" onClick={ this.handleFontBtnClick }>Pick Color</button>
                                                                { this.state.displayFontColorPicker ? <div style={ popover }>
                                                                  <div style={ cover } onClick={ this.handleFontBtnClose }/>
                                                                  <ChromePicker 
                                                       color={ this.state.notificationSettings.NotificationFontColor }
                                                        onChangeComplete={ this.handleFontColorChange } 
                                                          /> 
                                                                </div> : null }
                                                              </div>                                      
                                                            
                                                        </div>
                                                
                                            </div> 
                                            {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3") ?
                                            <div className="form-group">  
                                                    <label  className="col-sm-3 control-label">{t('Notification Setting.Text Font Size')}</label> 
                                                <div className="col-md-9">

                                                    <input 
                                                        type={'number'}
                                                        title= {t('Notification Setting.Text Font Size')}
                                                        name= {'NotificationFontSize'}
                                                        defaultValue={this.state.notificationSettings.NotificationFontSize} 
                                                        placeholder = {t('Notification Setting.Enter Font Size')}
                                                        onChange = {this.handleInput}
                                                        id="fSize"
                                                        className="form-control1 FR-edit-details" 
                                                        /> 
                                                </div> 
                                        </div>  : '' }
                                        {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3") ?
                                        <div className="form-group"> 
                                                    <label   className="col-sm-3 control-label">{t('Notification Setting.Notification Font')}</label>
                                                
                                <div className="col-md-9">
                                     <select  id="NotifFontDD"  className="form-control1 FR-edit-details"
                                            onChange={this.handleInput} 
                                            value = {this.state.NotificationFontType}
                                            placeholder="Select" 
                                            ref="NotificationFontType"
                                            name='NotificationFontType'
                                        >
                                            {optionNotifFont}
                                        </select> 
                                 </div> 
                            </div> : '' }
                                {(this.state.notificationSettings.NotifTypeId == "2" || this.state.notificationSettings.NotifTypeId == "3") ?
                                            <div className="form-group">
                                                <label className="col-sm-3 control-label">{t('Notification Setting.Text Font Type')}</label>
                                            
                                                <div className="col-md-9">
                                                        <div className="input-group">
                                                          <div className="checkbox setting-radio">
                                                            <label key="fonttype" className="checkbox-inline">
                                                             <input 
                                                                       id = "fTypebold"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="bold"
                                                                      key="bold" 
                                                                      type="checkbox" /> <i className="fa fa-bold" aria-hidden="true"></i>
                                                              </label>
                                                              <label key="" className="checkbox-inline" >
                                                              <input 
                                                                       id = "fTypeitallic"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="italic"
                                                                      key="italic" 
                                                                      type="checkbox" /> <i className="fa fa-italic" aria-hidden="true"></i>
                                                              </label>
                                                              <label className="checkbox-inline" >
                                                                    <input 
                                                                       id = "fTypeunderline"
                                                                      name="Type"
                                                                      onChange={this.handleInput}
                                                                      value="underline"
                                                                      key="underline" 
                                                                      type="checkbox" /> <i className="fa fa-underline" aria-hidden="true"></i>
                                                                  </label>
                                                          </div>
                                                        
                                                        </div>
                                                    </div>
                                                
                                            </div> : '' }
                                            <div className="form-group">
                                            <label  className="col-sm-3 control-label">{t('Notification Setting.Send Date and Time')}</label>  
                                                <div className="col-md-9">
                                                        {   this.state.sendNoti == "Later" ?
                                                            <div className={this.state.notificationSettings.NotifSend==true ? 'input-group disabled-notiTypes' : 'input-group'}>
                                                              <div className="checkbox setting-radio">
                                                                <label key="NotificationSendNow" className="checkbox-inline" value="Send Now">
                                                                    <input 
                                                                      id = "NotifSendNow" 
                                                                      name="NotifSendNow"
                                                                      onChange={this.handleInput}
                                                                      value="Now"
                                                                      key="Now" 
                                                                      type="radio" />  {t('Notification Setting.Send Now')}
                                                                  </label>
                                                                  <label  className="checkbox-inline" >
                                                                    <input 
                                                                      id = "NotifSendLater"
                                                                      name="NotifSendNow"
                                                                      onChange={this.handleInput}
                                                                      value="Later"
                                                                      key="Later" 
                                                                      type="radio" />  {t('Notification Setting.Schedule Later')}
                                                                  </label>
                                                              </div>
                                                            </div> : '' }
                                                    {   this.state.sendNoti == "Now" ?
                                                        <div className="send-now"> 
                                                            <p>{t('Notification Setting.Send Now')}</p> 
                                                            <p>{t('Notification Setting.Date')} : {this.state.sendNowDate} </p>
                                                            <p>{t('Notification Setting.Time')} : {this.state.sendNowTime}</p>
                                                        </div> : ''
                                                    }
                                                    {   (this.state.notificationSettings.NotifSendNow == true && this.state.sendNoti == "Later") ?
                                                        <div  className="send-now">
                                                            <p>{t('Notification Setting.Send Now')}</p> 
                                                            <p>{t('Notification Setting.Date')} : {this.state.sendNowDate} </p>
                                                            <p>{t('Notification Setting.Time')} : {this.state.sendNowTime}</p>
                                                        </div> : ''
                                                    }
                                                        </div> 
                                                 <label  className="className="col-sm-3 control-label> </label>  
                                                <div className="col-md-offset-3 col-md-9 send-now-input">
                                                {
                                                        this.state.notificationSettings.NotifSendNow == false ?
                                                        <div className={this.state.notificationSettings.NotifSend==true ? 'disabled-notiTypes' : ''}>
                                                           {/* <InputWithExtra 
                                                           type={'date'}
                                                           id="NotifSendDate"
                                                           title= {t('Notification Setting.Notification send date')}  
                                                           name= {'NotifSendDate'} 
                                                           value={this.state.notificationSettings.NotifSendDate} 
                                                           placeholder = {''}
                                                           onChange = {this.handleInput} 
                                                           min = {this.state.todayDate}
                                                           /> */}
                                                           <DatePickerInput
                                                                locale={currentLang}
                                                                id="NotifSendDate"
                                                                value={this.state.notificationSettings.NotifSendDate}
                                                                onChange={this.handleSendDate}
                                                                title= {t('Notification Setting.Notification send date')}
                                                                minDate = {this.state.todayDate}
                                                                displayFormat='YYYY-MM-DD'
                                                                returnFormat='YYYY-MM-DD'
                                                                showOnInputClick
                                                            />
                                                           <br/>
                                                            <InputWithExtra 
                                                            type={'time'}
                                                            title= {t('Notification Setting.Notification send time')}
                                                            name= {'NotifSendTime'} 
                                                            value={this.state.notificationSettings.NotifSendTime} 
                                                            placeholder = {''}
                                                            onChange = {this.handleInput} 
                                                            className="form-control1 FR-edit-details"
                                                           /> 
                                                        </div> 
                                                           : ''
                                                    }
                                                {/* <input 
                                                    type={'date'}
                                                    id="NotifSendDate"
                                                    title= {'NotifSendDate'} 
                                                    name= {'NotifSendDate'} 
                                                     value={this.state.notificationSettings.NotifSendDate} 
                                                    placeholder = {''}
                                                    onChange = {this.handleInput} 
                                                    className="form-control1" 
                                                    />   */}
                                                        </div> 
                                            </div> 
                                            <div className={this.state.showExpiry ? 'form-group disabled-notiTypes' : 'form-group'}>  
                                                    <label  className="col-sm-3 control-label">{t('Notification Setting.Expiry Date and Time')}</label>  
                                                <div className="col-md-9">
                                                {/* <input 
                                                    id="NotifExpiryDate"
                                                    type={'date'}
                                                    title= {t('Notification Setting.Notification expiry date')} 
                                                    name= {'NotifExpiryDate'} 
                                                    value={this.state.notificationSettings.NotifExpiryDate} 
                                                    placeholder = {''}
                                                    onChange = {this.handleInput} 
                                                    className="form-control1" 
                                                    min = {this.state.todayDate}
                                                    /> */}
                                                <DatePickerInput
                                                    locale={currentLang}
                                                    id="NotifExpiryDate" 
                                                    value={this.state.notificationSettings.NotifExpiryDate}
                                                    onChange={this.handleExpiryDate}
                                                    title= {t('Notification Setting.Notification expiry date')}
                                                    minDate = {this.state.todayDate}
                                                    displayFormat='YYYY-MM-DD'
                                                    returnFormat='YYYY-MM-DD'
                                                    showOnInputClick
                                                />
                                                <br/> <br/>
                                                <InputWithExtra 
                                                    className="form-control1 FR-edit-details"
                                                    type={'time'}
                                                    title= {t('Notification Setting.Notification expiry time')} 
                                                    name= {'NotifExpiryTime'} 
                                                    value={this.state.notificationSettings.NotifExpiryTime} 
                                                    placeholder = {''}
                                                    onChange = {this.handleInput} 
                                                    />          
                                                        </div>  
                                                     
                                            </div>  
                                        <div className="form-group"> 
                                            <div className="col-sm-offset-5 col-sm-6">      
                                            <p>
                                            <button 
                                                type="button"
                                                className="btn btn-primary general-btn" 
                                                onClick={() => { this.updateNotificationSettings() }}
                                                >
                                                {t('First_Responder.Save')}
                                            </button>
                                            {
                                                this.props.notificationSettings.isLoading?
                                                <img src={loader} width="30" alt="" />:''
                                            }
                                            </p>
                                            </div>
                                        </div>
                                   
                                   
                                 </form>
                                        </div>
                                    </div>
                                </div>      
                           
                            </div>                           
                           
                        
                    </div>
                </Modal>
            
            </div>
        )
    }
}

export default withNamespaces()(withRouter(NotificationDetailsComponent));